const DATA_MANAGEMENT = "fd-dm";
const QAQC = "fd-qaqc";
const STUDIO = "fd-studio";
const INTELLIGENCE = "fd-intel";
const AGENTIC = "fd-agentic";
const SETTINGS = "fd-settings";

const ROUTE_MODULE = {
  DataManagement: DATA_MANAGEMENT,
  Fields: DATA_MANAGEMENT,
  Wells: DATA_MANAGEMENT,
  Samples: DATA_MANAGEMENT,
  OilTest: DATA_MANAGEMENT,
  GasTest: DATA_MANAGEMENT,
  SampleInformation: DATA_MANAGEMENT,
  SampleValidation: DATA_MANAGEMENT,
  DifferentialLiberationSection: DATA_MANAGEMENT,
  ConstantCompositionExpansion: DATA_MANAGEMENT,
  MultiStageSeparatorTest: DATA_MANAGEMENT,
  OilViscosity: DATA_MANAGEMENT,
  Composition: DATA_MANAGEMENT,
  CvdTest: DATA_MANAGEMENT,

  QAQCIndex: QAQC,
  QAQCOverview: QAQC,
  QAQCDetailSample: QAQC,
  QAQCDetailReport: QAQC,
  QAQCDetailView: QAQC,
  UnifiedTestView: QAQC,

  FluidsDataStudioTwo: STUDIO,

  fluidsdatapal: INTELLIGENCE,

  AgenticDashboard: AGENTIC,
  AgenticDashboardAll: AGENTIC,
  AgenticDashboardStarred: AGENTIC,
  AgenticDashboardShared: AGENTIC,
  AgenticDashboardView: AGENTIC,

  UsersModule: SETTINGS,
  RolesModule: SETTINGS,
};

export function moduleClassForRoute(routeName) {
  return ROUTE_MODULE[routeName] || "";
}
